module.exports = __webpack_public_path__ + "img/help2_species_selection.e93a9f38.png";